import React, { useContext, useEffect, useState, useRef } from 'react'
import Header from '../../components/common/Header'
import HeaderBlock from "../../components/common/HeaderBlock"
import { ButtonPinkIcon } from '../../components/common/Button'
import { Input, TextArea } from '../../components/common/Input'
import { Chip, Connection } from '../../components/profile'
import { DarkModeContext } from '../../global/Theme'
import { AuthProvider } from '../../global/Auth'
import { SuccessValidator, ErrorValidator, GrayValidator } from '../../components/common/Validator'
import { useHistory } from 'react-router-dom'
import EditProfilePic from '../../components/modals/EditProfilePic'

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useSelector } from 'react-redux'

import './editprofilecreator.sass'

// to velidate username 
import LovrFire from '../../lovrfire'
import { getUserByID, updateUserData } from '../../api/auth'
import { useDispatch } from 'react-redux'
import { uploadProfilePic } from '../../api/feed'

export default function EditProfileViewer() {
    const { isDark } = useContext(DarkModeContext);
    const { userData } = useContext(AuthProvider);
    const history = useHistory()
    const [isEdited, setIsEdited] = useState(false);
    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [editDP, setEditDP] = useState("");
    const cropModal = useSelector(state => state.cropModal);
    const dispatch = useDispatch()

    // use effect for the mobile version of the page
    const updateWindowWidth = () => {
        setBodyWidth(document.body.clientWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        if (bodyWidth <= 586) {
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            document.getElementById('mobileNav').style.display = "none"
            document.getElementById('desktopNav').style.display = "flex"

        }
        else if (bodyWidth > 786) {
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopWrapper').style.display = 'flex';
            document.getElementById('mobileNav').style.display = "flex"
            document.getElementById('desktopNav').style.display = "flex"
        }

        return () => {
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopWrapper').style.display = 'flex';
        }
    }, [bodyWidth])

    useEffect(() => {
        if (document.body.clientWidth <= 786) {
            document.getElementById('mobileNav').style.display = "none"
            document.getElementById('desktopNav').style.display = "flex"
        } else {
            document.getElementById('mobileNav').style.display = "flex"
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopWrapper').style.display = 'flex';
        }
    })


    // handles back action
    const handleBackClick = () => {
        history.push({
            pathname: "/profile",
        })
    }


    // implementation of state change detection of the various input feilds ( this is the only way i could think of :/ )

    const userDataStore = useSelector(state => state.userState)

    useEffect(() => {
        setSex(userDataStore.sex)
    }, [userDataStore])

    const [viewerName, setViewerName] = useState(userDataStore.name);
    const [viewerUsername, setViewerUsername] = useState(userDataStore.username);
    const [viewerBio, setViewerBio] = useState(userDataStore.bio);
    const [website, setWebsite] = useState(userDataStore.socialMedia.website)
    const [pornhub, setPornhub] = useState(userDataStore.socialMedia.pornhub)
    const [instagram, setInstagram] = useState(userDataStore.socialMedia.instagram)
    const [twitch, setTwitch] = useState(userDataStore.socialMedia.twitch)
    const [spotify, setSpotify] = useState(userDataStore.socialMedia.spotify)
    const [snapchat, setSnapchat] = useState(userDataStore.socialMedia.snapchat)
    const [twitter, setTwitter] = useState(userDataStore.socialMedia.twitter)
    const [tiktok, setTiktok] = useState(userDataStore.socialMedia.tiktok)
    const [sex, setSex] = useState(userDataStore.sex)
    const [isUsernameValid, setIsUsernameValid] = useState(-1)
    const [dpBase64, setDpBase64] = useState(null);
    const [isUpdated, setIsUpdated] = useState(false)
    const [usernameError, setUsernameError] = useState(false);
    const [uploading, setUploading] = useState(false);

    const [displayNameCount, setDisplayNameCount] = useState(0);
    const displayNameRef = useRef();

    const [bioCount, setBioCound] = useState(0);
    const [bioError, setBioError] = useState(false);
    const bioRef = useRef()



    useEffect(() => {
        if (sex !== userDataStore.sex || viewerName !== userDataStore.name || viewerUsername !== userDataStore.username || viewerBio !== userDataStore.bio || website !== userDataStore.socialMedia.website || twitch !== userDataStore.socialMedia.twitch || twitter !== userDataStore.socialMedia.twitter || tiktok !== userDataStore.socialMedia.tiktok || spotify !== userDataStore.socialMedia.spotify || instagram !== userDataStore.socialMedia.instagram || pornhub !== userDataStore.socialMedia.pornhub || snapchat !== userDataStore.socialMedia.snapchat) {
            setIsEdited(true)
            console.log("settting true")
            document.getElementById('saveChangesButton').style.cursor = 'pointer';
            if (viewerName === "") {
                // setViewerName(userDataStore.name)
                setIsEdited(false)
            }
            if (viewerUsername === "") {
                // setViewerUsername(userDataStore.username)
                setIsEdited(false)
            }
            if (viewerBio === "") {
                // setViewerBio(userDataStore.bio)
            }
            if (website === "") {
                // setWebsite(userDataStore.socialMedia.website)
            }
            if (pornhub === "") {
                // setPornhub(userDataStore.socialMedia.pornhub)
            }
            if (tiktok === "") {
                // setTiktok(userDataStore.socialMedia.tiktok)
            }
            if (twitter === "") {
                // setTwitter(userDataStore.socialMedia.twitter)
            }
            if (twitch === "") {
                // setTwitch(userDataStore.socialMedia.twitch)
            }
            if (instagram === "") {
                // setInstagram(userDataStore.socialMedia.instagram)
            }
            if (spotify === "") {
                // setSpotify(userDataStore.socialMedia.spotify)
            }
            if (snapchat === "") {
                // setSnapchat(userDataStore.socialMedia.snapchat)
            }
            if (viewerUsername.length < 3 || !isUsernameValid) {
                console.log('setting is editied false')
                setIsEdited(false)
            }
        } else {
            setIsEdited(false)
            document.getElementById('saveChangesButton').style.cursor = 'not-allowed';
        }
    }, [viewerName, viewerUsername, viewerBio, website, twitch, twitter, tiktok, spotify, instagram, pornhub, snapchat, sex, isUsernameValid])

    const handleName = async (e) => {
        if (e.target.value.length <= 30) {
            setViewerName(e.target.value)
            setDisplayNameCount(e.target.value.length);
        } else {
            displayNameRef.current.value = viewerName;
        };

    }

    const handleUsername = (e) => {
        setViewerUsername(e.target.value);
    }

    const handleBio = (e) => {
        if (e.target.value.length <= 160) {
            setViewerBio(e.target.value)
            setBioCound(e.target.value.length);
        } else {
            bioRef.current.value = viewerBio;
        };
        setViewerBio(e.target.value);
    }

    const handleWebsite = (e) => {
        setWebsite(e.target.value);
    }

    const handletwitch = (e) => {
        setTwitch(e.target.value);
    }

    const handlePornhub = (e) => {
        setPornhub(e.target.value);
    }

    const handleSpotify = (e) => {
        setSpotify(e.target.value);
    }

    const handleInstagram = (e) => {
        setInstagram(e.target.value);
    }

    const handleSnapchat = (e) => {
        setSnapchat(e.target.value);
    }

    const handleTwitter = (e) => {
        setTwitter(e.target.value);
    }

    const handleTiktok = (e) => {
        setTiktok(e.target.value);
    }

    // useEffect(() => console.log(isEdited), [])


    const handleSaveChanges = async () => {
        if (isEdited && isUsernameValid) {
            const editedUserData = {
                bio: viewerBio,
                socialMedia: {
                    'twitter': twitter,
                    'instagram': instagram,
                    'twitch': twitch,
                    'spotify': spotify,
                    'tiktok': tiktok,
                    'website': website,
                    'snapchat': snapchat,
                    'pornhub': pornhub
                },
                name: viewerName,
                sex: sex,
                username: viewerUsername.toLowerCase().trim(),
            }
            try {
                await updateUserData(editedUserData);
                const updatedData = await getUserByID(userDataStore.id);
                dispatch({
                    type: 'UPDATE_USER_DATA', payload: updatedData
                })
                setIsUpdated(true);
                dispatch({
                    type: 'SET_NOTIFICATION', payload: {
                        isEnabled: true,
                        text: 'Changes Saved',
                        icon: 'notifcomment.svg'
                    }
                })
                await sleep(3000)
                dispatch({
                    type: 'SET_NOTIFICATION', payload: {
                        isEnabled: false,
                        text: '',
                        icon: ''
                    }
                })
                setIsUpdated(false)
                setIsEdited(false)
            } catch (e) {

            }
        }
    }


    useEffect(() => {
        validateUsername(viewerUsername, 0)
        console.log(viewerUsername, "is cahnged")
        setIsEdited(true)
        LovrFire.firestore().collection('users').onSnapshot(v => {
            for (var i = 0; i < v.docs.length; i++) {
                if (v.docs[i].data().username === viewerUsername && viewerUsername != userDataStore.username && isUpdated == true) {
                    validateUsername(viewerUsername, 1)
                    break
                } else if (viewerUsername != userDataStore.username) {
                    setIsEdited(true)
                }
            }
        })
    }, [viewerUsername])

    const validateUsername = (username, type) => {
        var expr = /^[a-zA-Z0-9.]*$/;
        if (!expr.test(username)) {
            setIsUsernameValid(3)
            setUsernameError(true)
            return;
        }
        if (type == 1) {
            setIsUsernameValid(2)
            setUsernameError(true)
        }
        else if (username.length < 3 && type == 0) {
            setIsUsernameValid(0)
            setUsernameError(true)
        }
        else {
            setIsUsernameValid(1)
            setUsernameError(false)
        }
    }

    const openCropModal = (e) => {
        if (e.target.files.length > 0) {
            setEditDP(URL.createObjectURL(e.target.files[0]));
            dispatch({
                type: 'TOGGLE_CROP_MODAL'
            });
        }

    }

    const handleImageData = async (e) => {
        setUploading(true)
        setDpBase64(e.getCroppedCanvas().toDataURL())
        // console.log("calling function", dpBase64)
        await uploadProfilePic(e.getCroppedCanvas().toDataURL())
        setUploading(false);
        dispatch({
            type: 'TOGGLE_CROP_MODAL'
        });
    }

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }



    return (
        <div id="editProfileCreator">
            {cropModal && editDP != null && <EditProfilePic img={editDP} uploading={uploading} handleImageData={handleImageData} />}
            <div id="editProfileCLeft">
                <Header img="backbutton.svg" text="Edit Profile VIewer" handleClick={handleBackClick} />
                <div className="edit-profile-user">
                    <div className="edit-profile-user-image">
                        {dpBase64 != null ? <img src={dpBase64} /> : userDataStore.image != "" ? <img src={userDataStore.image} /> : <img src={require('../../assets/img/creatorpic.svg')} />}
                    </div>
                    <div className="edit-profile-user-dets">
                        <h1 className={isDark ? 'edit-profile-dark' : ''}>{userDataStore.name}</h1>
                        <label for="dpImage">
                            <ButtonPinkIcon img="photo.svg" text="Edit profile picture" />
                        </label>
                        <input
                            style={{ display: "none" }}
                            onChange={openCropModal}
                            id="dpImage"
                            type="file"
                            accept="image/*"
                        />
                    </div>
                </div>
                <div className="edit-profile-input">
                    <h4>Display name</h4>
                    <Input refer={displayNameRef} autocapitalize={1} isError={false} handleInputChange={handleName} type='text' setValue={setViewerName} value={viewerName} placeholder="Enter Name" icon='user.svg' />
                    <p id="displayNameCount"><span className={displayNameCount == 30 ? 'error-display-name' : ''}>{displayNameCount}</span>/30</p>


                    {/* <Input icon="profile.svg" placeholder={viewerName} handleInputChange={handleName} /> */}
                </div>

                <div className="edit-profile-input">
                    <h4>Username</h4>
                    <Input
                        isError={viewerUsername.length > 0 && usernameError}
                        handleInputChange={handleUsername}
                        type='text'
                        value={viewerUsername}
                        setValue={setViewerUsername}
                        placeholder='Enter Username'
                        icon='user.svg' />
                    <div className="edit-profile-username-validator">

                        {isUsernameValid != -1 && viewerUsername.length > 0 ?
                            isUsernameValid == 0 ? <ErrorValidator text="Username is to short" /> :
                                isUsernameValid == 2 ? <ErrorValidator text="Username already taken" /> :
                                    isUsernameValid == 3 ? <ErrorValidator text="Only . is allowed as special char" /> :
                                        viewerUsername == userDataStore.username ? '' : <SuccessValidator text="Username available" /> :
                            <GrayValidator text="Username availability" />}
                    </div>
                </div>

                <div className="edit-profile-share-link">
                    <img src={require('../../assets/icons/pshare.svg')} />
                    <CopyToClipboard text={`https://lovr.online/user/${userDataStore.username}`}
                        onCopy={async () => {
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: true,
                                    text: 'Link copied to Clipboard',
                                    icon: 'notifcomment.svg'
                                }
                            })
                            await sleep(3000)
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: false,
                                    text: '',
                                    icon: ''
                                }
                            })
                        }}>
                        <p>Share link: <span>https://lovr.online/user/{userDataStore.username}</span></p>
                    </CopyToClipboard>
                </div>

                <div className="edit-profile-input">
                    <h4>Bio <span>(optional)</span></h4>
                    <h5>Maximum 160 characters</h5>
                    <TextArea
                        refer={bioRef}
                        isError={viewerBio.length > 0 && bioError}
                        icon="book.svg"
                        value={viewerBio}
                        placeholder="Enter Bio"
                        handleInputChange={handleBio} />

                    <p className='bio-count'>
                        <span className={bioCount == 160 ? 'error-display-name' : ''}>{bioCount}</span>/160</p>
                </div>

                <div className="edit-profile-gender">
                    <h4>What interests you?</h4>
                    <div className="edit-profile-gender-row">
                        <Chip text="MALE" isActive={(sex === 0)} onclick={() => { setSex(0) }} />
                        <Chip text="FEMALE" isActive={(sex === 1)} onclick={() => { setSex(1) }} />
                        <Chip text="BOTH" isActive={(sex === 2)} onclick={() => { setSex(2) }} />
                    </div>
                </div>
            </div>
            <div id="editProfileCRight">
                <HeaderBlock text="Connections" img="url.svg" />

                <Connection
                    value={website}
                    prefix='https://'
                    img={'website.png'}
                    handleInputChange={handleWebsite}
                />
                <Connection
                    value={instagram}
                    prefix='instagram.com/'
                    img={'instagram.png'}
                    handleInputChange={handleInstagram} />
                <Connection
                    value={spotify}
                    prefix='spotify.com/'
                    img={'spotify.png'}
                    handleInputChange={handleSpotify} />
                <Connection
                    value={tiktok}
                    prefix='tiktok.com/'
                    img={'tiktok.png'}
                    handleInputChange={handleTiktok} />
                <Connection
                    value={snapchat}
                    prefix='snapchat.com/'
                    img={'snapchat.png'}
                    handleInputChange={handleSnapchat} />
                <Connection
                    value={pornhub}
                    prefix='pornhub.com/'
                    img={'pornhub.png'}
                    handleInputChange={handlePornhub} />
                <Connection
                    value={twitch}
                    prefix='twitch.com/'
                    img={'twitch.png'}
                    handleInputChange={handletwitch} />
                <Connection
                    value={twitter}
                    prefix='twitter.com/'
                    img={'twitter.png'}
                    handleInputChange={handleTwitter} />

                <div id="editProfileAction" onClick={handleSaveChanges} >
                    <h1>{isEdited}</h1>
                    <div id='saveChangesButton' className={`edit-profile-button-save-button ${isUpdated ? 'success' : (isEdited) ? '' : isDark ? 'disabled-dark' : 'disabled-light'} `}>
                        <img src={require(isEdited ? '../../assets/icons/tick.svg' : isUpdated ? '../../assets/icons/tick.svg' : '../../assets/icons/tick_a.svg')} />
                        <p>SAVE CHANGES {isEdited} </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
